import {
  PostApiSpoRetailFamiliesBody,
  SpoRetailFamiliesReponse,
} from '@spo/types';
import { apiBff } from '.';

export interface RetailFamiliesParams {
  searchInput: string;
  familyIds: number[];
  date: string;
  language?: string;
  limit?: number;
}

export const getRetailFamilies = async (
  postApiSpoRetailFamiliesBody: PostApiSpoRetailFamiliesBody,
): Promise<SpoRetailFamiliesReponse> => {
  return apiBff.callBFF(
    'POST',
    'spo/retail_families',
    postApiSpoRetailFamiliesBody,
  );
};
